import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100); // Small delay to ensure the page has re-rendered
    };

    window.addEventListener("popstate", scrollToTop);
    scrollToTop(); 

    return () => {
      window.removeEventListener("popstate", scrollToTop);
    };
  }, [location]);

  return null;
};

export default ScrollToTop;




// import { useEffect } from "react";
// import { NavigationType, useLocation, useNavigationType } from "react-router-dom";

// const useBackButton = () => {
//   const navType = useNavigationType();
//   return navType === NavigationType.Pop;
// };



// const ScrollToTop = () => {
//   const { pathname } = useLocation();
//   console.log(pathname)

//   const isPop = useBackButton();
//   console.log(isPop)

//   const scrollToTop = () => window.scrollTo(0, 0);

//   useEffect(() => {
//     scrollToTop();
//   }, [pathname, isPop]);

//   useEffect(() => {
//     window.addEventListener("beforeunload", scrollToTop);
//     return () => {
//       window.removeEventListener("beforeunload", scrollToTop);
//     };
//   }, []);
// };

// export default ScrollToTop;